import { Field, useFormikContext } from 'formik'

import ToggleWithLabel from 'components/ToggleWithLabel'

import { STANDS_PAYMENT_TENDER_SETTINGS } from 'resources'

const PaymentTenderSettings = ({ title }) => {
  const { values, setFieldValue } = useFormikContext()

  const standsSettings = values?.standsSettings

  return (
    <section className="item-settings__section">
      <h3 className="header-title">{title}</h3>
      {STANDS_PAYMENT_TENDER_SETTINGS?.map(({ name, title }) => {
        return (
          <div className="content-wrapper -block" key={name}>
            <Field
              component={ToggleWithLabel}
              checked={standsSettings[name]}
              label={title}
              onChange={(e) =>
                setFieldValue(
                  `standsSettings.${name}`,
                  e.target.checked
                )
              }
              name={`standsSettings.${name}`}
              dataCy={name}
            />
          </div>
        )
      })}
    </section>
  )
}

export default PaymentTenderSettings
